module.exports = __webpack_public_path__ + "static/media/auger-empty.a659e7ac.png";